const regex = /Edge?\/(8[5-9]|9\d|\d{3,})(\.\d+|)(\.\d+|)|Firefox\/(7[7-9]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(13[._]([4-9]|\d{2,})|(1[4-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|SamsungBrowser\/(1[4-9]|[2-9]\d|\d{3,})\.\d+/

const isModernBrowser = ua => regex.test(ua)
export default isModernBrowser
